import * as React from "react";
import { observer } from "mobx-react";
import ProgressiveImage from "react-progressive-image";
import { CSSTransition } from "react-transition-group";
import cone from "common/assets/images/coneTransparente.png";

import { Typography, withStyles } from "@material-ui/core";

import i18n from "i18n";
// import classNames from 'classnames';

const styles = (theme) => ({
  container: {
    marginTop: "100px",
    textAlign: "center" as any,
    margin: "0 auto",
    "& > :first-child": {
      marginBottom: "20px",
    },
  },
  title: {
    fontFamily: "Raleway",
    fontSize: "26px",
    fontWeight: 300,
    color: "#212121",
    margin: "15px 0",
  },
  subtitle: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: 300,
    color: "#5c5c5c",
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
});

type IProps = {
  classes: any;
  target?: any;
  subtarget?: any;
  replaceTarget?: any;
  replaceSubtarget?: any;
};

@observer
class NoResultsFound extends React.Component<IProps> {
  render() {
    const { classes } = this.props;

    return (
      <ProgressiveImage src={cone} placeholder="coneTransparente.png">
        {(src, loading) => (
          <CSSTransition
            in={!loading}
            enter={true}
            exit={false}
            timeout={300}
            classNames={{
              enter: classes.transitionEnter,
              enterActive: classes.transitionEnterActive,
            }}
            unmountOnExit
          >
            <div className={classes.container}>
              <img src={src} />
              <Typography className={classes.title}>
                {this.props.replaceTarget !== null &&
                this.props.replaceTarget !== undefined
                  ? this.props.replaceTarget
                  : i18n.noresults.noexisting +
                    " " +
                    this.props.target +
                    " " +
                    i18n.noresults.message}
              </Typography>
              <Typography className={classes.subtitle}>
                {this.props.replaceSubtarget !== null &&
                this.props.replaceSubtarget !== undefined
                  ? this.props.replaceSubtarget
                  : i18n.noresults.createnew +
                    " " +
                    this.props.subtarget +
                    " " +
                    i18n.noresults.click}
              </Typography>
            </div>
          </CSSTransition>
        )}
      </ProgressiveImage>
    );
  }
}

export default withStyles(styles)(NoResultsFound);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/NoResultsFound.tsx